<template lang="pug">
div
  .LayerSettings
    .LayerSettings-left
      .Params
        .Params-field
          .Params-label.Params-label--required Название слоя
          input.TextInput.TextInput--block(
            type='text',
            maxlength='255',
            v-model='params.name'
          )
          .Params-error(v-if='showErrors && !params.name') Обязательное поле

        .Params-field(v-if='!layerSettings')
          label
            input.Checkbox.Checkbox--middle(
              type='checkbox',
              v-model='isLinear'
            )
            span Линейный слой

        .Params-field(v-if='isLinear')
          label
            input.Checkbox.Checkbox--middle(
              type='checkbox',
              v-model='params.is_trip'
            )
            span Расчитывать маршруты и их длину

        .Params-field(v-if='isLinear')
          .Params-label Цвет слоя
          .Params-select
            color-select(
              :options='colors',
              :initialValue='params.color',
              @input='changeParam($event, "color")'
            )
        .Params-field(v-else)
          .Params-label Иконка слоя
          .Params-select
            custom-select(
              :options='iconList',
              @input='changeParam($event, "icon")',
              :value='params.icon',
              :isBoldSelected='true',
              :font-size='12',
              placeholder='Выбрать иконку'
            )

        .Params-field.Params-field--inlineblock
          switcher(v-model='params.active') Видимость слоя на карте

        .Params-field.Params-select
          custom-multiple-select(
            :options='wsList',
            :searchEnabled='true',
            :selectedText='selectedWsText',
            :initialValue='params.allowed_workspaces',
            @updateValue='changeParam($event, "allowed_workspaces")'
          )
          .Params-error(v-if='showErrors && (!params.allowed_workspaces || params.allowed_workspaces.length === 0)')
            | Нужно выбрать хотя бы одно рабочее пространство

        .Params-field(v-if='layerId === "new"')
          .Params-label.Params-label--required Файл
          file-upload(
            :initialFile='params.file',
            @changeFile='changeParam($event, "file")',
            :types='types'
          )
          .Params-error(v-if='showErrors && (!params.file || (!params.file.file && !params.file.url))') Обязательное поле
    .LayerSettings-right.Columns
      h3(v-if='layerId === "new"') Настройки столбцов будут доступны после инициализации слоя из файла
      h3(v-else) Настройки столбцов
      .ColumnsAdd(v-if='layerId !== "new"')
        .ColumnsAdd-label Столбец
        .ColumnsAdd-input
          input.TextInput.TextInput--block(
            type='text',
            v-model='newHeaderName'
          )
        .ColumnsAdd-action
          button.Btn.Btn--block.Btn--blueColor.Btn--light(@click='addHeader') Добавить
      .ColumnsList(v-if='layerId !== "new"')
        .Columns-item.Item
          .Item-name Наименование
          .Item-filters(style='padding-left: 24px') Фильтры
          .Item-checkbox Отображать в списке
          .Item-remove
        draggable(
          group='headers',
          v-model='params.headers',
          :options='{ handle: ".IconDraggable" }'
        )
          .Columns-item.Item(v-for='(header, headerIndex) in params.headers')
            .Item-name
              .Item-drag
                i.Icon.IconDraggable
              .Item-text {{ header.rus_name || header.name_in_table }}
            .Item-filters
              custom-multiple-select(
                :options='filterDict',
                :initialValue='header.filters',
                @updateValue='setFilters(headerIndex, $event)'
              )
            .Item-checkbox
              label
                input(
                  type='checkbox',
                  v-model='header.show'
                )
                span
            .Item-remove
              button.Btn.BtnIcon(
                v-if='header.id !== "id"',
                @click='removeHeader(header.id)'
              )
                i.Icon.IconClose

  .ModalFooter.ExcelObjects-footer
    .ModalFooter-left
      button.Btn.Btn--blue.Btn--light(
        @click='save',
        :disabled='isSaving'
      ) Сохранить изменения
      router-link.Btn.Btn--light.Btn--red(
        tag='button',
        :to='{ name: "excel-layer-list" }'
      ) Выйти из режима редактирования
    .ModalFooter-right(v-if='layerId !== "new"')
      button.Btn.Btn--outline.BtnIcon.Btn--remove.Btn--light(
        v-if='$store.getters.permissions.canDeleteAggregateInfoLayer',
        @click='removeLayer'
      )
        i.Icon.IconRemove
        | Удалить
</template>

<script>
import FileUpload from '@/components/FileUpload'
import Switcher from '@/components/Switcher'
import CustomSelect from '@/components/CustomSelect'
import ColorSelect from '@/components/ColorSelect'
import draggable from 'vuedraggable'

export default {
  name: 'excel-layer-settings',

  components: {
    CustomSelect,
    ColorSelect,
    FileUpload,
    Switcher,
    draggable,
    'custom-multiple-select': () => import('@/components/CustomMultipleSelect')
  },

  data() {
    return {
      types: ['xls', 'xlsx'],
      showErrors: false,
      isSaving: false,
      newHeaderName: '',
      isLinear: false,
      params: {
        name: '',
        active: false,
        color: [],
        allowed_workspaces: [],
        file: null,
        icon: null,
        headers: []
      }
    }
  },

  computed: {
    filterDict() {
      return this.$store.getters.objectfilterDict
        ? this.$store.getters.objectfilterDict.groups.map((group) => {
            return {
              id: group.id,
              name: group.name
            }
          })
        : null
    },
    layerId() {
      return this.$route.params.layerId
    },
    layerSettings() {
      return this.$store.getters.excelLayerSettings
    },
    wsList() {
      return (this.$store.getters.activeWorkspaceList || []).map((wsItem) => {
        return {
          ...wsItem,
          name: wsItem.fullName
        }
      })
    },
    selectedWsText() {
      return this.params.allowed_workspaces.length > 0
        ? this.params.allowed_workspaces.map((v) => this.wsList.filter((item) => item.id === parseInt(v))[0].name).join(', ')
        : 'Выбрать рабочие пространства'
    },
    colors() {
      return this.$store.getters.excelLayerColorList
    },
    colorsMap() {
      return this.$store.getters.excelLayerColorMap
    },
    iconList() {
      return this.$store.getters.excelLayerIconList
        .filter((v) => v.type === 'point_layers')
        .map((v) => {
          return {
            name: v.name,
            id: v.id,
            icon: {
              type: 'img',
              file: v.icon_file.file
            }
          }
        })
    },
    workspace() {
      return this.$store.getters.workspace
    }
  },

  watch: {
    iconList() {
      if (!this.layerSettings) {
        return
      }
      const icon = this.iconList ? this.iconList.filter((v) => v.id === this.layerSettings.icon) : []
      this.changeParam(icon.length > 0 ? icon[0] : null, 'icon')
    },
    colors() {
      if (this.colors.length > 0) {
        const color = this.layerSettings && this.layerSettings.color && this.colorsMap[this.layerSettings.color] ? [this.layerSettings.color] : []
        this.changeParam(color, 'color')
      }
    },
    params(newVal) {
      if (this.layerSettings) {
        this.isLinear = newVal.headers.filter((v) => v.id === 'sinkpoint').length > 0 && newVal.headers.filter((v) => v.id === 'sourcepoint').length > 0
      }
    }
  },

  mounted() {
    if (!this.filterDict) {
      this.$store.dispatch('getFilterDict').then((r) => {
        this.initParams()
      })
    } else {
      this.initParams()
    }

    if (this.iconList.length === 0) {
      this.$store.dispatch('getExcelLayersIconList')
    }
    if (this.colors.length === 0) {
      this.$store.dispatch('getExcelLayersColorList')
    }
  },

  methods: {
    initParams() {
      if (!this.layerSettings) {
        this.params.color = this.colors[0] ? [this.colors[0].id] : []
        //По умолчанию слой создается для текущего ws
        if (this.workspace) {
          this.params.allowed_workspaces = [this.workspace.toString()]
        }
        return
      }
      const icon = this.iconList ? this.iconList.filter((v) => v.id === this.layerSettings.icon) : []
      const currentColor = this.layerSettings.color && this.colorsMap[this.layerSettings.color] ? [this.layerSettings.color] : []
      this.params = {
        ...this.layerSettings,
        allowed_workspaces: (this.layerSettings.allowed_workspaces || []).filter((v) => this.wsList.findIndex((item) => item.id === v) > -1),
        icon: icon.length > 0 ? icon[0] : null,
        color: currentColor,
        headers: JSON.parse(JSON.stringify(this.layerSettings.headers)).map((header) => {
          const filters = []
          Object.keys(this.layerSettings.filters_fields).forEach((filterId) => {
            if (this.layerSettings.filters_fields[filterId].findIndex((fId) => fId === header.name_in_table) > -1) {
              filters.push(filterId)
            }
          })
          return {
            ...header,
            filters
          }
        })
      }
    },
    setFilters(index, value) {
      this.params.headers[index] = {
        ...this.params.headers[index],
        filters: value
      }
      this.params = {
        ...this.params,
        headers: [...this.params.headers]
      }
    },
    changeParam(value, paramName) {
      this.params = {
        ...this.params,
        [paramName]: value
      }
    },
    addHeader() {
      if (!this.newHeaderName) {
        return
      }
      if (this.params.headers.filter((v) => v.id === this.newHeaderName).length > 0) {
        this.$ui.toast.show({ text: 'Такой столбец уже существует', type: 'error', time: 5000 })
        return
      }

      this.params = {
        ...this.params,
        headers: this.params.headers.concat([
          {
            id: this.newHeaderName,
            name_in_table: this.newHeaderName,
            show: true,
            filters: []
          }
        ])
      }
      this.newHeaderName = ''
    },
    removeHeader(header) {
      this.params = {
        ...this.params,
        headers: this.params.headers.filter((v) => v.id !== header)
      }
    },
    removeLayer() {
      this.$store
        .dispatch('deleteExcelObject', {
          id: this.layerId
        })
        .then((v) => {
          this.$router.replace({ name: 'excel-layer-list' })
          this.$ui.toast.show({ text: 'Слой и все его записи удалены', time: '5000', type: 'success' })
        })
        .catch((e) => {
          this.$ui.toast.show({ text: 'Ошибка удаления слоя и его записей', time: '5000', type: 'error' })
        })
    },
    save() {
      this.showErrors = true
      if (!this.validateParam()) {
        return
      }
      const filters_fields = {}
      this.params.headers.forEach((header) => {
        header.filters.forEach((filter) => {
          if (filters_fields[filter]) {
            filters_fields[filter].push(header.name_in_table)
          } else {
            filters_fields[filter] = [header.name_in_table]
          }
        })
      })
      const headers = this.params.headers.map((v) => {
        delete v.filters
        return v
      })
      const iconFieldName = this.params.id ? 'icon_id' : 'icon'
      const colorValue = this.params.color[0] ? this.colorsMap[this.params.color[0]] : null
      const params = {
        ...this.params,
        headers,
        filters_fields,
        color: colorValue ? colorValue.id : null,
        allowed_workspaces: this.params.allowed_workspaces.map((v) => parseInt(v)),
        [iconFieldName]: this.params.icon ? this.params.icon.id : null,
        file: this.params.file ? this.params.file.file : null
      }
      delete params.isLinear
      if (iconFieldName === 'icon_id') delete params.icon
      this.isSaving = true
      if (this.layerId === 'new') {
        this.$ui.toast.show({ text: 'Создание слоя', time: '60000', type: 'progress' })
        this.$store
          .dispatch('createExcelLayer', params)
          .then((v) => {
            this.$router.replace({ name: 'excel-layer-list' })
            this.$ui.toast.show({ text: 'Cлой создан. Процесс обработки слоя может занять некоторое время', time: '5000', type: 'success' })
          })
          .catch((e) => {
            this.isSaving = false
            this.$ui.toast.show({ text: 'Ошибка создания слоя', time: '5000', type: 'error' })
          })
      } else {
        this.$store
          .dispatch('updateExcelLayerSettings', {
            id: this.layerId,
            params
          })
          .then((v) => {
            this.$router.replace({ name: 'excel-layer-list' })
            this.$ui.toast.show({ text: 'Настройки слоя изменены', time: '5000', type: 'success' })
          })
          .catch((e) => {
            this.isSaving = false
            this.$ui.toast.show({ text: 'Ошибка сохранения настроек слоя', time: '5000', type: 'error' })
          })
      }
    },

    validateParam() {
      if (!this.params.name) {
        return false
      }

      if (this.layerId === 'new' && (!this.params.file || !this.params.file.file)) {
        return false
      }

      if (!this.params.allowed_workspaces || this.params.allowed_workspaces.length === 0) {
        return false
      }

      return true
    }
  }
}
</script>

<style scoped lang="scss">
@import '~base';
#app .LayerSettings {
  --rightBg: #{$grey7};
}

#app[data-theme='dark'] .LayerSettings {
  --rightBg: #{$black3};
}

.Columns {
  h3 {
    font-size: 14px;
    line-height: 16px;
    font-weight: 500;
  }

  &Add {
    display: flex;
    align-items: center;
    font-size: 12px;

    .Btn {
      font-weight: 500;
      border: 1px solid var(--delimiter);
    }

    .TextInput,
    .Btn {
      background: var(--appBg);
    }

    .TextInput {
      border: 0;
    }

    &-label {
      flex: 0 0 auto;
    }

    &-input {
      flex: 1 1 auto;
      margin: 0 12px;
    }

    &-action {
      flex: 0 0 103px;
    }
  }

  &List {
    margin: 32px 0;

    & > .Item {
      font-size: 12px;
      font-weight: 400;
      line-height: 14px;
    }
  }

  &-item {
    display: flex;
    align-items: center;
  }
}
.Item {
  border-bottom: 1px solid var(--delimiter);
  font-size: 14px;
  line-height: 16px;
  font-weight: 500;

  & > * {
    padding: 9px 12px;
  }
  &-name {
    position: relative;
    flex: 1 1 auto;
    padding-left: 32px;
  }

  &-drag {
    position: absolute;
    width: 15px;
    height: 25px;
    left: -2px;
    top: 50%;
    margin-top: -13px;
    color: var(--secondaryText);
    text-align: center;
    cursor: pointer;
    opacity: 0.5;
    line-height: 25px;

    .Icon {
      font-size: 16px;
    }

    &:hover {
      opacity: 1;
    }
  }

  &-checkbox {
    flex: 0 0 100px;
  }

  &-filters {
    flex: 0 0 35%;
  }

  &-remove {
    flex: 0 0 64px;
    text-align: center;

    button {
      height: 20px;
    }

    .Icon {
      font-size: 16px;
      color: var(--secondaryText);
    }

    button:hover .Icon {
      color: var(--accentColor);
    }
  }
}

.LayerSettings {
  display: flex;
  height: calc(100vh - 137px);
  color: var(--basicText);

  &-left,
  &-right {
    flex: 0 0 50%;
    overflow: auto;
    height: 100%;
  }
  &-right {
    padding: 24px;
    background: var(--rightBg);
  }
  &-left {
    padding: 24px 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/excel-layers/ExcelLayerSettings.vue